<template>
   <a-dialog v-model="show" scrollable max-width="35vw" persistent>
    <v-card>
      <v-banner
        class="voting-cnf"
        color="primaryLight1"
        dark
        sticky
        single-line
        tile
      >
        <v-toolbar color="primaryLight1" dark>
          <span>
            {{ $t("agenda.lblComment") }}
          </span>
          <v-spacer></v-spacer>
          <CloseIcon @click="$emit('input', false)" />
        </v-toolbar>
      </v-banner>
      <v-card-text class="black--text">
        <v-row no-gutters>
          <v-col cols="12" sm="12">
            <span
              v-html="
                $t('poll.textLeaveComment')
              "
            ></span
          ></v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="12">
            <v-text-field
              v-model.trim="txtComment"
              prepend-icon="mdi-comment"
              class="mt-4"
              :label="$t('agenda.lblComment')"
              :rules="rules"
              :max="1000"
              maxlength="1000"
              counter="1000"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              ref="primaryButton"
              color="primaryDark"
              class="font-weight-bold"
              small
              :disabled="!isCommentValid"
              @click="onOkClick"
            >
              <span>{{ $t("btnOk") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("btnOk") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              small
              color="secondary"
              class="font-weight-bold ml-2"
              @click="onClose"
              ><span>{{ $t("btnLabelCancel") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("btnLabelCancel") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
export default {
  name: "LikertTypeComment",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    comment: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      txtComment: this.comment,
      rules: [(v) => v.length <= 1000 || this.$t('ruleQuestionMaxLength')],
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    isCommentValid() {
      return String(this.txtComment).length <= 1000;
    },
  },
  methods: {
    onOkClick,
    onClose,
  },

};
function onOkClick() {
  this.$emit("change", String(this.txtComment).trim());
  this.$emit("input", false);
  this.txtComment = "";
}

function onClose() {
  this.$emit("cancel");
  this.$emit("input", false);
}
</script>

<style scoped>
::v-deep .voting-cnf .v-banner__wrapper {
  padding: 0px !important;
}
</style>